"use client"

import Image from "next/image"
import { useEffect, useState } from "react"

const STORAGE_KEY = "smartBannerClosed"

type Platform = "ios" | "android" | null

export const SmartBanner = () => {
  const [platform, setPlatform] = useState<Platform>(null)

  useEffect(() => {
    const wasClosed = sessionStorage.getItem(STORAGE_KEY)
    if (wasClosed === "true") {
      return
    }

    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream
    const isAndroid = /android/i.test(userAgent)

    if (isIOS) {
      setPlatform("ios")
    } else if (isAndroid) {
      setPlatform("android")
    }
  }, [])

  if (!platform) {
    return null
  }

  const handleClose = () => {
    setPlatform(null)
    sessionStorage.setItem(STORAGE_KEY, "true")
  }

  const handleOpenStore = () => {
    const storeUrl =
      platform === "ios"
        ? "https://apps.apple.com/nl/app/goodshift/id1573545734"
        : "https://play.google.com/store/apps/details?id=foundation.goodplace.app"
    window.open(storeUrl, "_blank")
    handleClose()
  }

  const storeText = platform === "ios" ? "Gratis - In de App Store" : "Gratis - In Google Play"

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="flex-shrink-0">
            <Image
              src="/goodshift/pwaLogoBg.svg"
              alt="GoodShift"
              width={48}
              height={48}
              className="w-12 h-12 rounded-lg object-cover border border-gray-200 shadow-sm"
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold text-gray-900 truncate">GoodShift</div>
            <div className="text-xs text-gray-500 truncate">{storeText}</div>
          </div>
        </div>
        <div className="flex items-center gap-2 ml-3">
          <button
            onClick={handleOpenStore}
            className="px-4 py-2 bg-purple text-white text-sm font-medium rounded-lg hover:bg-purple/90 transition-colors whitespace-nowrap">
            Bekijk
          </button>
          <button
            onClick={handleClose}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Sluit banner">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
